<template>
<!-- 通知对象 -->
  <div>
    <modal :title="$t('device.notice')" :visible.sync="isShowDialog" width="600px" append-to-body @close="close">
      <el-form ref="form" :model="dioForm">
        <!-- 切换结果通知 -->
        <el-form-item>
          <el-checkbox v-model="noticeChecked" @change="noticeChange">{{ $t('device.switch_result_notice') }}</el-checkbox>
        </el-form-item>
        <!-- 新增通知对象 -->
        <el-form-item>
          <NoticeObject ref="notice" />
        </el-form-item>


      </el-form>
      <div slot="footer">
          <el-button type="primary" @click="close">{{ $t('public.btn_close') }}</el-button>
          <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
      </div>
    </modal>

  </div>
</template>

<script>
import { carrierNoticeSave, carrierNoticeSaveBatch, getCarrierNotice } from '@/api/modules/carrier'
import NoticeObject from '@/components/NoticeObject/index.vue'


export default {
  name: 'NoticeDialog',
  components: {
    NoticeObject
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    choozeTableData: {
      type: Array,
      default: () => []
    },
    isBatch: {
      type: Boolean,
      default: false
    },
    carrierDeviceId: {
      type: Number | String,
      default: ''
    },
    type: {
      type: Number | String,
      default: 0
    },
    // 判断安装点是第一次新增还是编辑，第一次新增的时候通知为空，就不用调接口获取了，不然会报错
    isFirstAdd: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    choozeTableData (newVal) {
      this.tableData = [...newVal]
    },
    isShowDialog(){
      if(this.isShowDialog && !this.isBatch  && !this.isFirstAdd){
        this.getCarrierNoticeList()
      }
    }
  },
  data() {
    return {
      tableData: [], // 选择的设备列表
      dioForm: {
        carrierDeviceId: null, //安装点id
        noticeClxList: []
      },
      selectObjectList: [], // 已选择的通知对象
      noticeChecked: false, // 是否开启通知
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    }
  },
  methods: {
    // 保存选择的通知对象
    async handleSave(){
      console.log('this.noticeChecked=',this.noticeChecked)
      if(this.noticeChecked){
        const params = {
          noticeClxList: []
        }
        if(this.isBatch){
          params.carrierIdList = this.choozeTableData.map(_ => _.id)
        }else{
          params.carrierDeviceId = parseInt(this.carrierDeviceId)
        }
        // 获取通知对象数据
        let selectObjectList = this.$refs.notice.selectObjectList
        console.log('selectObjectList=', selectObjectList)
        selectObjectList.forEach(obj => {
          params.noticeClxList.push({
            isSyn: obj.isSyn ? obj.isSyn : 0,
            notice: {
              way: '' + obj.smsOpen + obj.emailOpen + obj.phoneOpen,
              name: obj.name,
              email: obj.email,
              phone: obj.phone
            }
          })
        })

        // 新增安装点时，不需要单独调保存通知接口
        if(this.isFirstAdd){
            this.$emit('selectNotice', params.noticeClxList)
        }else{
          let request = null
          if(this.isBatch){
            request = carrierNoticeSaveBatch(this.type, params)
          }else{
            request = carrierNoticeSave(this.type, params)
          }
          request.then(res => {
            if (res.state.code === 200) {
              this.$message.success($t('integration.success'))
              this.$emit('selectNotice', params.noticeClxList)
            }
          })
        }

      }
      this.close()
    },
    // 是否开启通知
    noticeChange(checked){
      this.noticeChecked = checked
    },

    close(){
      this.$emit('close')
      if(!this.isFirstAdd){
        this.selectObjectList = []
        this.$refs.notice.setNoticeList([])
        this.noticeChecked = false
      }
    },
    getCarrierNoticeList() {
      getCarrierNotice(this.type, this.carrierDeviceId).then(res => {
        if (res.state.code === 200) {
          this.selectObjectList = res.result && res.result.length ? res.result : []
          // 因为获取的通知列表数据没有isSyn字段
          // this.selectObjectList.forEach(item => {
          //   item.isSyn = 0
          //   // 处理way
          //   let wayArr = item.way.split('')
          //   item.smsOpen = parseInt(wayArr[0])
          //   item.emailOpen = parseInt(wayArr[1])
          //   item.phoneOpen = parseInt(wayArr[2])
          // })
          // 设置通知对象
          this.$refs.notice.setNoticeList(this.selectObjectList)
          // 如果有通知对象，切换结果就打钩
          if(this.selectObjectList.length){
            this.noticeChecked = true
          }

        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add_object_btn {
  ::v-deep i {
    color: #FFFFFF !important;
  }
  .dropdown-btn {
    width: 100%;
  }
  .dropdown-item {
    margin: 2px 0;
  }
}
.icon_btns {
  i {
    margin: 0 5px;
    font-size: 20px;
    &:last-child {
      float: right;
    }
  }
}
.items {
  display: flex;
  margin-bottom: 8px;
  .item-icon {
    padding: 5px;
    border: 1px solid #CCCCCC;
    font-size: 18px;
  }
  .item-name {
    width: 360px;
    background-color: var(--primary-color);
    text-align: center;
    color: #FFFFFF;
  }
}

</style>
